import type { RefObject } from "react";
import { useEffect, useState } from "react";
import type { TextInput } from "react-native";

/** focus target element when trigger element is focused */
export const useForwardFocus = (target: RefObject<TextInput | null>) => {
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (focused && target.current) {
      target.current.focus();
    }
  }, [focused, target]);
  /** apply this object on focus trigger element */
  return {
    onPress: () => {
      setFocused(true);
    },
    onBlur: () => {
      setFocused(false);
    },
    focusable: true
  };
};